module.exports = __webpack_public_path__ + "static/media/star-blue.5133d0cb.svg";